import type { UUID } from '$domain/types';

export interface SessionContext {
  nodeId: UUID | null; // El nodo hoja seleccionado
  path: UUID[];        // La ruta completa (para el breadcrumb)
}

export type MacroTimerState =
  | 'inactive'
  | 'focus_running'
  | 'focus_paused'
  | 'break_running'
  | 'break_paused'
  | 'pending_finish'
  | 'finished'
  | 'discarded';

export type ProblemTimerState = 'idle' | 'running' | 'evaluating';

export type SessionMode = 'A' | 'B';

export interface MacroTimer {
  state: MacroTimerState;
  focusDurationMs: number;
  breakDurationMs: number;
  openEnded: boolean;
  readingDurationMs: number;
  focusStartedAt: number | null;
  breakStartedAt: number | null;
  focusAccumulatedMs: number;
  breakAccumulatedMs: number;
  readingAccumulatedMs: number;
  distractions: number;
  pausedAt: number | null;
}

export interface ProblemTimer {
  state: ProblemTimerState;
  startedAt: number | null;
  stoppedAt: number | null;
  elapsedMs: number;
  mode: 'timer' | 'countdown';
  countdownDurationMs: number;
}

export const DEFAULT_FOCUS_MS = 25 * 60 * 1000;
export const DEFAULT_BREAK_MS = 5 * 60 * 1000;
export const PRESET_FOCUS_MINUTES = [25, 50, 90] as const;
export const PRESET_BREAK_MINUTES = [5, 10, 20] as const;